import { createAction } from '@reduxjs/toolkit';

export const initializeChildOptions = createAction('bom/initializeChildOptions');

export const initializeQuantity = createAction('bom/initializeQuantity');

export const initializeQuestions = createAction('bom/initializeQuestions');

export const initializeRelations = createAction('bom/initializeRelations');

export const initializeSizeChart = createAction('bom/initializeSizeChart');

export const initializeUniqueOptions = createAction('bom/initializeUniqueOptions');

export const initializeUniqueOptionsBackup = createAction('bom/initializeUniqueOptionsBackup');

export const saveQuantity = createAction('bom/saveQuantity');

export const selectLeafMultipleSelectionOption = createAction(
  'bom/selectLeafMultipleSelectionOption',
  (code, key, quantities) => {
    return { payload: { code, key, quantities } };
  }
);

export const deselectLeafMultipleSelectionOption = createAction(
  'bom/deselectLeafMultipleSelectionOption',
  (code, key) => {
    return { payload: { code, key } };
  }
);

export const selectMultipleSelectionOption = createAction(
  'bom/selectMultipleSelectionOption',
  (code, codeValue, quantity) => {
    return { payload: { code, codeValue, quantity } };
  }
);

export const deselectMultipleSelectionOption = createAction(
  'bom/deselectMultipleSelectionOption',
  (code, codeValue) => {
    return { payload: { code, codeValue } };
  }
);

export const toggleSingleSelectionOption = createAction('bom/toggleSingleSelectionOption', (code, codeValue) => {
  return { payload: { code, codeValue } };
});

export const updateUniqueOptions = createAction('bom/updateUniqueOptions', (uniqueOptionDict) => {
  return { payload: { uniqueOptionDict } };
});

export const setCurrentParentChildOptionEditingInfo = createAction(
  'bom/setCurrentParentChildOptionEditingInfo',
  (isEditing, parentOption, parentQuestion) => {
    return { payload: { isEditing, parentOption, parentQuestion } };
  }
);

export const resetCurrentParentChildOptionEditingInfo = createAction('bom/resetCurrentParentChildOptionEditingInfo');

export const setShowSizeChartForMobileLite = createAction('bom/setShowSizeChartForMobileLite');
